module.exports = __webpack_public_path__ + "static/media/cq_cassetto_digitale b.3c361063.svg";